import styled from 'styled-components';
import { color } from '@deerplusofficial/pos-helper';

const InfoSection = styled.div`
  padding: 20px 0;
  border-bottom: 1px solid ${color.border};
`;

export default InfoSection;



// WEBPACK FOOTER //
// ./src/components/Info/InfoSection.js